import { getCore } from '../../../client/core/getCore';
import type { DynamicCoreState } from '../../../client/core/types';
import type { DynamicClient } from '../../../client/types';
import { isEqualShallow } from '../../../utils/isEqualShallow';
import { emitEvent } from '../../clientEvents';
import { stateChangeEvents } from './events';

export const raiseStateEvents = (client: DynamicClient) => {
  const core = getCore(client);

  core.state.subscribe((value, previous) => {
    const eventEntries = Object.entries(stateChangeEvents) as Array<
      [keyof DynamicCoreState, keyof DynamicEvents]
    >;

    eventEntries.forEach(([key, event]) => {
      // Check if this key had a change
      if (isEqualShallow(value[key], previous[key])) return;

      emitEvent(
        {
          args: { [key]: value[key] },
          event,
        },
        client
      );
    });
  });
};
